<ng-container *ngFor="let promo of promotionalTexts">
  <div *ngIf="promo && promo !== ''" class="promotional-text-container">
    <ng-container
      *ngIf="
        promotionLocation === 'CART' || promotionLocation === 'CAROUSEL' || promotionLocation === 'NORMALCAROUSEL';
        else noTruncate
      "
    >
      <app-tooltip-text
        class="badge badge-primary"
        [tooltipContent]="promo"
        [content]="promo"
        [charactersLimit]="charactersLimit"
        placement="bottom"
        [ngClass]="[
          promotionLocation === 'CART' ? 'cart-promo' : 'text-truncate',
          hasMemoField === 'true' ? '' : 'noMemo'
        ]"
      >
      </app-tooltip-text>
    </ng-container>
    <ng-template #noTruncate>
      <app-tooltip-text
        class="badge badge-primary text-truncate"
        [tooltipContent]="'product.promo' | cxTranslate"
        [content]="promo"
        [promotionLocation]="promotionLocation"
        placement="bottom"
      >
      </app-tooltip-text>
    </ng-template>
  </div>
</ng-container>
